import gql from 'graphql-tag';

export interface CreatePaymentData {
  createPayment: {
    _id: string;
  };
}

export interface CreatePaymentVars {
  payment_status: number;
  payment_type: string;
  employee: string;
  payee: string;
  vendor?: string | null;
  payer?: string;
  round_paid: string;
  system_request: string;
  number_ref?: string;
  ref_id?: string;
  payment_remark: string;
  payment_list: {
    datamaster_service_item_id: string;
    advance_type: boolean;
    list_number: string;
    list_name: string;
    qty: number;
    unit: string;
    price: number;
    discount: number;
    vat: number;
    wht: number;
  }[];
  reject_remark?: string;
  cancel_remark?: string;
  service_date: string;
  costing?: string;
  invoice_date: string;
  invoice_due_date: string;
  document_list?: string[];
  vendor_invoice_id: string;
  department: string | null;
  fixed_asset_check?: number;
}

export default gql`
  mutation CreatePayment(
    $payment_status: Int!
    $payment_type: String!
    $employee: ID!
    $payee: ID!
    $vendor: ID
    $payer: ID
    $round_paid: String!
    $system_request: String
    $number_ref: String
    $ref_id: ID
    $payment_remark: String
    $payment_list: [inputPaymentList]
    $reject_remark: String
    $cancel_remark: String
    $service_date: String
    $costing: ID
    $invoice_date: String
    $invoice_due_date: String
    $document_list: [String]
    $vendor_invoice_id: String
    $department: String
    $fixed_asset_check: Int
  ) {
    createPayment(
      createPayment: {
        payment_status: $payment_status
        payment_type: $payment_type
        employee: $employee
        payee: $payee
        vendor: $vendor
        payer: $payer
        round_paid: $round_paid
        system_request: $system_request
        number_ref: $number_ref
        ref_id: $ref_id
        payment_remark: $payment_remark
        payment_list: $payment_list
        reject_remark: $reject_remark
        cancel_remark: $cancel_remark
        service_date: $service_date
        costing: $costing
        invoice_date: $invoice_date
        invoice_due_date: $invoice_due_date
        document_list: $document_list
        vendor_invoice_id: $vendor_invoice_id
        department: $department
        fixed_asset_check: $fixed_asset_check
      }
    ) {
      _id
    }
  }
`;
